import { Storage } from '@capacitor/storage';
import type { UserStoragePrefs } from './types';

/**
 * What the user has agreed may be stored.
 *
 * Written by components/common/Gdpr.tsx. Nothing read it before this: the
 * answer went into storage and was never consulted, so the dialog — on the
 * occasions it was reachable at all — recorded a preference the product then
 * ignored.
 *
 * Reading it is only half the job. The flags are now sent with a scan so the
 * API *can* honour them; until it does, they are a record of what was agreed
 * rather than an enforcement of it. That enforcement belongs server-side,
 * where the images actually land.
 */
export const NOTHING_AGREED: UserStoragePrefs = {
    model_inputs: false,
    orig_images: false,
    results: false,
};

export async function readConsent(): Promise<UserStoragePrefs> {
    try {
        const stored = await Storage.get({ key: 'consent' });
        if (!stored.value) return NOTHING_AGREED;
        return { ...NOTHING_AGREED, ...(JSON.parse(stored.value) as UserStoragePrefs) };
    } catch {
        // Unparseable or unavailable storage is not agreement.
        return NOTHING_AGREED;
    }
}

/** True once the dialog has been answered, whatever the answer was. */
export async function hasAnsweredConsent(): Promise<boolean> {
    try {
        return (await Storage.get({ key: 'saved' })).value === 'true';
    } catch {
        return false;
    }
}
